module.exports = __webpack_public_path__ + "img/KB Pomorze logo.dba99764.png";